import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/Store";
import { useLocation, useNavigate } from "react-router-dom";
import MuiPagination from "../../../common-components/pagination/Pagination";

import SelectList, { components } from "react-select";
import { Controller, useForm, useWatch } from "react-hook-form";
import ControlledSelectList from "../../../common-components/CommonReactSelect";
import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { IconType } from "react-icons";
import axios from "axios";
import dayjs from "dayjs";
import { debounce, useMediaQuery } from "@mui/material";
import CommonHeader from "../../../common-components/FUNCTION";
import PreviewDialog from "../PreviewExisting";
import { API } from "../../../constants/tableConstants/API";
import {
  clearAsapData,
  fetchASAPDataPagination,
  resetKddPagination,
  setCurrentPageASAP,
  setIsUploading,
  setLoading,
  setSortState,
  updateselectedAsapTitleList,
  updateselectedFileNameASAP,
  updateselectedMarketingList,
} from "../../../redux/reducers/ASAPReducer";
import { FetchMarketingactivity, setLoadingofFileASAP, setLoadingofMarketing, setLoadingofTitleASAP } from "../../../redux/reducers/MarketingActivity";
import { FetchASAPTitleOptions } from "../../../redux/reducers/AsapTitleOptionReducer";
import { FetchAsapFileNameOptions } from "../../../redux/reducers/ASAPFileReducer";
import { SetLoadingofkddTitle } from "../../../redux/reducers/TitleReducer";

export interface OptionType {
  value: string;
  label: string;
}

const ASAPTable: React.FC = () => {
  const { Asapdata, loading, error } = useSelector(
    (state: RootState) => state.ASAPReducer
  );
  const {
    MarketingactivityOption,
    hasMore: hasMoreDate,
    currentPage: currentpageDate,
    limit: limitDate,
    loading: loadingDate,
  } = useSelector((state: RootState) => state.MarketingActivityReducer);
  console.log(MarketingactivityOption, "MarketingactivityOption");
  const {
    AsapTitleOption,
    limit: limitTitle,
    hasMore: hasMoreTitle,
    currentPage: currentPageTitle,
    loading: loadingTitle,
  } = useSelector((state: RootState) => state.AsapTitleOptionReducer);
  console.log(AsapTitleOption, "TitleOption");
  const {
    AsapFilenameOption,
    limit: limitFilename,
    currentPage: currentPageFilename,
    hasMore: hasMoreFilename,
    loading: loadingFilename,
  } = useSelector((state: RootState) => state.ASAPFileReducer);
  const selectedMarketingList = useSelector(
    (state: RootState) => state.ASAPReducer.selectedMarketingList
  );
  const selectedAsapTitleList = useSelector(
    (state: RootState) => state.ASAPReducer.selectedAsapTitleList
  );
  const selectedAsapFilename = useSelector(
    (state: RootState) => state.ASAPReducer.selectedAsapFilename
  );
  console.log(
    selectedMarketingList,
    selectedAsapFilename,
    selectedAsapTitleList,
    "selectedAsapFilename"
  );
  const currentPageASAP = useSelector(
    (state: RootState) => state.ASAPReducer.currentPageASAP
  );
  const sortState = useSelector(
    (state: RootState) => state.ASAPReducer.sortState
  );
  console.log(sortState, "sortState");
  const scrolling = useSelector(
    (state: RootState) => state.ASAPReducer.scrolling
  );
  const ScrollhasMore = useSelector(
    (state: RootState) => state.ASAPReducer.hasMore
  );

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const hasPreselected = useRef(false);
  const uploadedFileNames = useLocation()?.state?.uploadedFileName;
  const [loadingTest, setLoadingTest] = useState(false);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: string;
  }>({
    key: "",
    direction: "",
  });
  const rowsPerPage = 10;
  const dispatch = useDispatch<AppDispatch>();
  const asapref = useRef<HTMLDivElement | null>(null);
  const { control, handleSubmit, watch, setValue, getValues } = useForm();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const MarketingactivityOptions = MarketingactivityOption.map(
    (option: any) => ({
      label: option.label,
      value: option.label,
    })
  );
  const ASAPtitleOption = AsapTitleOption.map((option: any) => ({
    label: option.label,
    value: option.label,
  }));
  console.log(AsapTitleOption, "titleOption");
  const ASAPFileOption = AsapFilenameOption.map((option: any) => ({
    label: option.label,
    value: option.label,
  }));

  const hasMore = useSelector((state: RootState) => state.ASAPReducer.hasMore);

  // Load filters from localStorage on mount
  useEffect(() => {
    const savedFilters = localStorage.getItem('asapFilters');
    if (savedFilters) {
      const { MarketingActivity, ASAPtitle, ASAPfilename } = JSON.parse(savedFilters);
      if (MarketingActivity?.length) {
        setValue('MarketingActivity', MarketingActivity);
        dispatch(updateselectedMarketingList(MarketingActivity));
      }
      if (ASAPtitle?.length) {
        setValue('ASAPtitle', ASAPtitle);
        dispatch(updateselectedAsapTitleList(ASAPtitle));
      }
      if (ASAPfilename?.length) {
        setValue('ASAPfilename', ASAPfilename);
        dispatch(updateselectedFileNameASAP(ASAPfilename));
      }
    }
  }, [dispatch, setValue]);

  // Save filters to localStorage whenever they change
  useEffect(() => {
    const filters = {
      MarketingActivity: selectedMarketingList,
      ASAPtitle: selectedAsapTitleList,
      ASAPfilename: selectedAsapFilename,
    };
    localStorage.setItem('asapFilters', JSON.stringify(filters));
  }, [selectedMarketingList, selectedAsapTitleList, selectedAsapFilename]);

  // Clear filters when navigating to a different page
  useEffect(() => {
    const handlePageChange = () => {
      dispatch(updateselectedMarketingList([]));
      dispatch(updateselectedAsapTitleList([]));
      dispatch(updateselectedFileNameASAP([]));
      setValue("MarketingActivity", []);
      setValue("ASAPtitle", []);
      setValue("ASAPfilename", []);
      localStorage.removeItem('asapFilters');
    };

    return () => {
      if (location.pathname !== window.location.pathname) {
        handlePageChange();
      }
    };
  }, [location.pathname, dispatch, setValue]);

  const handleScroll = useCallback(() => {
    if (!asapref.current || loading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = asapref.current;

    if (scrollTop + clientHeight >= scrollHeight - 50) {
      dispatch(setCurrentPageASAP(currentPageASAP + 1));
    }
  }, [dispatch, loading, hasMore]);

  console.log(
    currentPageFilename,
    "currentPageFilename",
    currentPageTitle,
    "currentPageTitle",
    currentpageDate,
    "currentpageDate",
    currentPageASAP,
    "pagesss"
  );

  useEffect(() => {
    console.log("handleScrollCalled", handleScroll);
    const scrollContainer = asapref.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => scrollContainer.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  useEffect(() => {
    if (currentPageASAP > 1) {
      console.log("currentPage in scroll", currentPageASAP);
      dispatch(
        fetchASAPDataPagination({
          page: currentPageASAP,
          limit: rowsPerPage,
        heading: sortState?.heading || "PRIMARY_ASIN",
          sortType: sortState?.sortType || 'desc',
          // secondarySort: sortState?.secondarySort, // Include secondary sort
          filters: {
            TITLE: selectTitle,
            Marketing_Activity: selectMarketing,
            FILE_NAME: selectedFile,
          },
        })
      );
    }
  }, [currentPageASAP]);

  const watchedDate = useWatch({ control, name: "MarketingActivity" });
  const watchedTitle = useWatch({ control, name: "ASAPtitle" });
  const watchedFilename = useWatch({ control, name: "ASAPfilename" });

  useEffect(() => {
    if (
      !Array.isArray(watchedDate) &&
      !Array.isArray(watchedTitle) &&
      !Array.isArray(watchedFilename)
    ) {
      return;
    }

    if (Array.isArray(watchedDate) && watchedDate.length > 0) {
      dispatch(updateselectedMarketingList(watchedDate));
    } else {
      dispatch(updateselectedMarketingList([]));
    }

    if (Array.isArray(watchedTitle) && watchedTitle.length > 0) {
      dispatch(updateselectedAsapTitleList(watchedTitle));
    } else {
      dispatch(updateselectedAsapTitleList([]));
    }

    if (Array.isArray(watchedFilename) && watchedFilename.length > 0) {
      dispatch(updateselectedFileNameASAP(watchedFilename));
    } else {
      dispatch(updateselectedFileNameASAP([]));
    }
  }, [watchedDate, watchedTitle, watchedFilename, dispatch]);

  const selectMarketing = selectedMarketingList?.map((data) => data.value);
  const selectTitle = selectedAsapTitleList?.map((data) => data.value);
  const selectedFile = selectedAsapFilename?.map((data) => data.value);
  console.log(selectMarketing, selectedFile, selectTitle, "selectedFile");

  useEffect(() => {
    dispatch(clearAsapData());
  }, []);

  useEffect(() => {
    const filters = {
      TITLE: selectTitle,
      Marketing_Activity: selectMarketing,
      FILE_NAME: selectedFile,
    };
    console.log("Fetching data with payload:", {
      page: currentPageASAP,
      limit: rowsPerPage,
      heading: sortState?.heading,
      sortType: sortState?.sortType,
      // secondarySort: sortState?.secondarySort,
      filters,
    });
    dispatch(
      FetchMarketingactivity({
        page: currentPageASAP,
        limit: rowsPerPage,
        searchTerm: "",
        TITLE: filters.TITLE,
        FILE_NAME: filters.FILE_NAME,
      })
    );
    dispatch(
      FetchAsapFileNameOptions({
        page: currentPageASAP,
        limit: rowsPerPage,
        searchTerm: "",
        MARKETING_ACTIVITY: filters.Marketing_Activity,
        TITLE: filters.TITLE,
      })
    );
    dispatch(
      FetchASAPTitleOptions({
        page: currentPageASAP,
        limit: rowsPerPage,
        searchTerm: "",
        MARKETING_ACTIVITY: filters.Marketing_Activity,
        FILE_NAME: filters.FILE_NAME,
      })
    );
    dispatch(
      fetchASAPDataPagination({
        page: currentPageASAP,
        limit: rowsPerPage,
  heading: sortState?.heading || "PRIMARY_ASIN",
          sortType: sortState?.sortType || 'desc',   
        // secondarySort: sortState?.secondarySort, // Include secondary sort
        filters: {
          TITLE: selectTitle,
          Marketing_Activity: selectMarketing,
          FILE_NAME: selectedFile,
        },
      })
    );

    if (
      !selectedMarketingList &&
      !selectedAsapTitleList &&
      !selectedAsapFilename
    ) {
      dispatch(resetKddPagination());
      dispatch(
        fetchASAPDataPagination({
          page: 1,
          limit: 10,
          filters: {},
        })
      );
    }
  }, [selectedMarketingList, selectedAsapTitleList, selectedAsapFilename]);

  const handleTitleBottom = () => {
    if (hasMoreTitle) {
      dispatch(setLoadingofTitleASAP(true));
      dispatch(
        FetchASAPTitleOptions({ page: currentPageTitle + 1, limit: limitTitle })
      );
    }
  };

  const handleScrollToBottom = () => {
    console.log("dateee");
    if (hasMoreDate) {
      dispatch(setLoadingofMarketing(true));
      dispatch(
        FetchMarketingactivity({ page: currentpageDate + 1, limit: limitDate })
      );
    }
  };

  const handleFileBottom = () => {
    if (hasMoreFilename) {
      dispatch(setLoadingofFileASAP(true));
      dispatch(
        FetchAsapFileNameOptions({
          page: currentPageFilename + 1,
          limit: limitFilename,
        })
      );
    }
  };

  const watchedFileName = useWatch({ name: "ASAPfilename", control });

  console.log(watchedFileName, watchedDate, watchedTitle, "watched values");

  const downloadAsapdata = async (data: any) => {
    dispatch(setLoading(true));
    try {
      const response = await axios.post(`${API.downloadASAPexportFile}`, data, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const a = document.createElement("a");
      a.href = url;
      const formatDate = dayjs().format("MMMM-DD-YYYY-HHmmss");
      a.download = `ASAP ${formatDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      dispatch(setLoading(false));
    } catch (err: any) {
      console.error("Error downloading file:", err);
      alert("Failed to download the file. Please try again.");
    } finally {
      dispatch(setLoading(false));
    }
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((inputValue: string) => {
        if (inputValue.length > 0) {
          dispatch(
            FetchMarketingactivity({
              page: currentpageDate,
              limit: rowsPerPage,
              searchTerm: inputValue,
              TITLE: selectTitle,
              FILE_NAME: selectedFile,
            })
          );
        }
      }, 800),
    [limitDate]
  );

  const debounceTitleSearch = useMemo(
    () =>
      debounce((inputValue: string) => {
        if (inputValue.length > 0) {
          dispatch(
            FetchASAPTitleOptions({
              page: currentPageTitle,
              limit: rowsPerPage,
              searchTerm: inputValue,
              MARKETING_ACTIVITY: selectMarketing,
              FILE_NAME: selectedFile,
            })
          );
        }
      }, 600),
    [limitTitle]
  );

  const debouncedMarketingSearch = useRef(
    debounce(
      (
        inputValue: string,
        page: number,
        limit: number,
        Title: any,
        fileName: any
      ) => {
        dispatch(
          FetchMarketingactivity({
            page,
            limit,
            searchTerm: inputValue,
            TITLE: Title,
            FILE_NAME: fileName,
          })
        );
      },
      500
    )
  ).current;

  const debouncedFetchTitle = useRef(
    debounce(
      (
        inputValue: string,
        page: number,
        limit: number,
        MarketingActivity: any,
        fileName: any
      ) => {
        dispatch(
          FetchASAPTitleOptions({
            page,
            limit,
            searchTerm: inputValue,
            MARKETING_ACTIVITY: MarketingActivity,
            FILE_NAME: fileName,
          })
        );
      },
      500
    )
  ).current;

  const debounceFileSearch = useRef(
    debounce(
      (
        inputValue: string,
        page: number,
        limit: number,
        marketingActivity: any,
        Title: any
      ) => {
        dispatch(
          FetchAsapFileNameOptions({
            page,
            limit,
            searchTerm: inputValue,
            MARKETING_ACTIVITY: marketingActivity,
            TITLE: Title,
          })
        );
      },
      500
    )
  );

   const handleSort = (heading: string, sortType: "asc" | "desc") => {
    dispatch(setSortState({ heading, sortType }));

    dispatch(setCurrentPageASAP(1));

    console.log("currentPage in handlesort", currentPageASAP);
    dispatch(
      fetchASAPDataPagination({
        page: 1,
        limit: rowsPerPage,
        heading: heading,
        sortType: sortType,
        filters: {
          TITLE: selectTitle,
          Marketing_Activity: selectMarketing,
          FILE_NAME: selectedFile,
        },
      })
    );
  };
  // const handleSort = (heading: string, sortType: "asc" | "desc") => {
  //   // Check if PRIMARY_ASIN is a valid column
  //   const isPrimaryAsinValid = Asapdata?.columns.includes("PRIMARY_ASIN");
  //   console.log("Is PRIMARY_ASIN valid?", isPrimaryAsinValid, "Columns:", Asapdata?.columns);

  //   if (!isPrimaryAsinValid) {
  //     console.warn("PRIMARY_ASIN column not found in data. Sorting only by primary column.");
  //   }

  //   const sortPayload = {
  //     heading,
  //     sortType,
  //     ...(isPrimaryAsinValid && { secondarySort: { heading: "PRIMARY_ASIN", sortType } }),
  //   };

  //   console.log("Sort payload:", sortPayload);

  //   dispatch(setSortState(sortPayload));
  //   dispatch(setCurrentPageASAP(1));
  //   console.log("currentPage in handlesort", currentPageASAP);
  //   dispatch(
  //     fetchASAPDataPagination({
  //       page: 1,
  //       limit: rowsPerPage,
  //       heading,
  //       sortType,
  //       ...(isPrimaryAsinValid && { secondarySort: { heading: "PRIMARY_ASIN", sortType } }),
  //       filters: {
  //         TITLE: selectTitle,
  //         Marketing_Activity: selectMarketing,
  //         FILE_NAME: selectedFile,
  //       },
  //     })
  //   );
  // };

  const handleClearAll = (e: any) => {
    e.preventDefault();
    dispatch(updateselectedMarketingList([]));
    dispatch(updateselectedAsapTitleList([]));
    dispatch(updateselectedFileNameASAP([]));
    setValue("MarketingActivity", []);
    setValue("ASAPtitle", []);
    setValue("ASAPfilename", []);
    localStorage.removeItem('asapFilters');
  };

  useEffect(() => {
    const isAllFieldsEmpty =
      !(selectedAsapFilename?.length ?? 0) &&
      !(selectMarketing?.length ?? 0) &&
      !(selectedAsapTitleList?.length ?? 0);
    setButtonDisabled(isAllFieldsEmpty);
  }, [selectedAsapFilename, selectMarketing, selectedAsapTitleList]);

  const formatHeader = (header: string): string => {
    return header
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <>
      <div className="flex md:flex-row flex-col md:gap-2">
        <div className="w-full py-1">
          <p className="text-[#e31c23] font-bold "> MARKETING ACTIVITY</p>
          <Controller
            name="MarketingActivity"
            control={control}
            render={({ field }) => {
              return (
                <div className="w-full">
                  <SelectList
                    {...field}
                    id="marketingActivity"
                    options={MarketingactivityOptions}
                    isClearable={true}
                    placeholder="Select Marketing Activity"
                    hideSelectedOptions={false}
                    menuPortalTarget={document.body}
                    onMenuOpen={() => {
                      dispatch(setLoadingofMarketing(false));
                      dispatch(
                        FetchMarketingactivity({
                          page: 1,
                          limit: rowsPerPage,
                          searchTerm: "",
                          TITLE: selectTitle,
                          FILE_NAME: selectedFile,
                        })
                      );
                    }}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") {
                        dispatch(setLoadingofMarketing(true));
                        debouncedMarketingSearch(
                          inputValue,
                          currentpageDate,
                          rowsPerPage,
                          selectTitle,
                          selectedFile
                        );
                      }
                    }}
                    onChange={(e) => {
                      dispatch(setLoadingofMarketing(true));
                      field.onChange(e);
                      dispatch(setCurrentPageASAP(1));
                    }}
                    onMenuScrollToBottom={handleScrollToBottom}
                    menuPlacement="auto"
                    isMulti
                    className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                    components={{
                      MultiValueContainer: (props) => (
                        <components.MultiValueContainer {...props}>
                          <div className="flex">{props.children}</div>
                        </components.MultiValueContainer>
                      ),
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        pointerEvents: loadingDate ? "none" : "auto",
                      }),
                      input: (provided) => ({
                        ...provided,
                        position: `${
                          watch("MarketingActivity")?.length
                            ? "relative"
                            : "absolute"
                        }`,
                        pointerEvents: loadingDate ? "none" : "auto",
                        left: 6,
                        marginRight: "10px",
                        caretColor: loadingDate ? "transparent" : "auto",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor:
                          state.isSelected || state.isFocused ? "#E6E6E6" : "",
                        color: state.isSelected ? "black" : "black",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "6px",
                        minWidth: "none",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: loadingDate ? -1 : 1050,
                        position: "absolute",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                      }),
                      valueContainer: (provided) => ({
                        position: "relative",
                        maxWidth: isSmallScreen ? "52vw" : "22vw",
                        width: "100%",
                        paddingLeft: "6px",
                        display: "flex",
                        alignItems: "center",
                        height: "40px",
                        paddingRight: "8px",
                        overflowX: "auto",
                        overflowY: "hidden",
                        minWidth: "50px",
                        boxSizing: "border-box",
                      }),
                      control: (provided) => ({
                        display: "flex",
                        height: "40px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }),
                      menuList: (provided) => ({
                        maxHeight: "200px",
                        overflow: "hidden",
                        overflowY: "auto",
                      }),
                      clearIndicator: () => ({
                        marginLeft: "15px",
                        marginTop: "5px",
                        color: "gray",
                      }),
                    }}
                  />
                </div>
              );
            }}
          />
        </div>

        <div className="w-full py-1">
          <p className="text-[#e31c23] font-bold "> TITLE</p>
          <Controller
            name="ASAPtitle"
            control={control}
            render={({ field }) => (
              <div className="w-full">
                <SelectList
                  {...field}
                  id="title"
                  options={ASAPtitleOption}
                  isClearable={true}
                  hideSelectedOptions={false}
                  placeholder="Select Title"
                  menuPortalTarget={document.body}
                  onChange={(e) => {
                    dispatch(setLoadingofTitleASAP(true));
                    field.onChange(e);
                    dispatch(setCurrentPageASAP(1));
                  }}
                  onMenuOpen={() => {
                    dispatch(setLoadingofTitleASAP(false));
                    dispatch(
                      FetchASAPTitleOptions({
                        page: 1,
                        limit: rowsPerPage,
                        searchTerm: "",
                        MARKETING_ACTIVITY: selectMarketing,
                        FILE_NAME: selectedFile,
                      })
                    );
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                      dispatch(setLoadingofTitleASAP(true));
                      debouncedFetchTitle(
                        inputValue,
                        currentPageTitle,
                        rowsPerPage,
                        selectMarketing,
                        selectedFile
                      );
                    }
                  }}
                  onMenuScrollToBottom={handleTitleBottom}
                  menuPlacement="auto"
                  isMulti
                  className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                  components={{
                    MultiValueContainer: (props) => (
                      <components.MultiValueContainer {...props}>
                        <div className="flex">{props.children}</div>
                      </components.MultiValueContainer>
                    ),
                  }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      pointerEvents: loadingTitle ? "none" : "auto",
                    }),
                    input: (provided) => ({
                      ...provided,
                      position: `${
                        watch("ASAPtitle")?.length ? "relative" : "absolute"
                      }`,
                      pointerEvents: loadingTitle ? "none" : "auto",
                      left: 6,
                      marginRight: "10px",
                      caretColor: loadingTitle ? "transparent" : "auto",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor:
                        state.isSelected || state.isFocused ? "#E6E6E6" : "",
                      color: state.isSelected ? "black" : "black",
                    }),
                    multiValue: (provided) => ({
                      ...provided,
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "6px",
                      minWidth: "none",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: loadingTitle ? -1 : 1050,
                      position: "absolute",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                    }),
                    valueContainer: (provided) => ({
                      position: "relative",
                      maxWidth: isSmallScreen ? "52vw" : "20vw",
                      width: "100%",
                      paddingLeft: "6px",
                      display: "flex",
                      alignItems: "center",
                      height: "40px",
                      paddingRight: "8px",
                      overflowX: "auto",
                      overflowY: "hidden",
                      minWidth: "50px",
                      boxSizing: "border-box",
                    }),
                    control: (provided) => ({
                      display: "flex",
                      height: "40px",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }),
                    menuList: (provided) => ({
                      maxHeight: "200px",
                      overflow: "hidden",
                      overflowY: "auto",
                    }),
                    clearIndicator: () => ({
                      marginLeft: "15px",
                      marginTop: "5px",
                      color: "gray",
                    }),
                  }}
                />
              </div>
            )}
          />
        </div>
        <div className="w-full py-1">
          <p className="text-[#e31c23] font-bold ">FILE NAME</p>
          <Controller
            name="ASAPfilename"
            control={control}
            render={({ field }) => (
              <div className="w-full">
                <SelectList
                  {...field}
                  id="fileName"
                  options={ASAPFileOption}
                  isClearable={true}
                  hideSelectedOptions={false}
                  placeholder="Select File name"
                  menuPortalTarget={document.body}
                  menuPlacement="auto"
                  isMulti
                  onMenuOpen={() => {
                    dispatch(setLoadingofFileASAP(false));
                    dispatch(
                      FetchAsapFileNameOptions({
                        page: 1,
                        limit: rowsPerPage,
                        searchTerm: "",
                        MARKETING_ACTIVITY: selectMarketing,
                        TITLE: selectTitle,
                      })
                    );
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                      dispatch(setLoadingofFileASAP(true));
                      debounceFileSearch.current(
                        inputValue,
                        currentPageFilename,
                        rowsPerPage,
                        selectMarketing,
                        selectTitle
                      );
                    }
                  }}
                  onChange={(e) => {
                    dispatch(setLoadingofFileASAP(true));
                    field.onChange(e);
                    dispatch(setCurrentPageASAP(1));
                  }}
                  onMenuScrollToBottom={handleFileBottom}
                  className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                  components={{
                    MultiValueContainer: (props) => (
                      <components.MultiValueContainer {...props}>
                        <div className="flex">{props.children}</div>
                      </components.MultiValueContainer>
                    ),
                  }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      pointerEvents: loadingFilename ? "none" : "auto",
                    }),
                    input: (provided) => ({
                      ...provided,
                      position: `${
                        watch("ASAPfilename")?.length ? "relative" : "absolute"
                      }`,
                      pointerEvents: loadingFilename ? "none" : "auto",
                      left: 6,
                      marginRight: "10px",
                      caretColor: loadingFilename ? "transparent" : "auto",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor:
                        state.isSelected || state.isFocused ? "#E6E6E6" : "",
                      color: state.isSelected ? "black" : "black",
                    }),
                    multiValue: (provided) => ({
                      ...provided,
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "6px",
                      minWidth: "none",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: loadingFilename ? -1 : 1050,
                      position: "absolute",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                    }),
                    valueContainer: (provided) => ({
                      position: "relative",
                      maxWidth: isSmallScreen ? "52vw" : "22vw",
                      width: "100%",
                      paddingLeft: "6px",
                      display: "flex",
                      alignItems: "center",
                      height: "40px",
                      paddingRight: "8px",
                      overflowX: "auto",
                      overflowY: "hidden",
                      minWidth: "50px",
                      boxSizing: "border-box",
                    }),
                    control: (provided) => ({
                      display: "flex",
                      height: "40px",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }),
                    menuList: (provided) => ({
                      maxHeight: "200px",
                      overflow: "hidden",
                      overflowY: "auto",
                    }),
                    clearIndicator: () => ({
                      marginLeft: "15px",
                      marginTop: "5px",
                      color: "gray",
                    }),
                  }}
                />
              </div>
            )}
          />
        </div>
        <div className=" flex flex-col md:flex-row justify-center items-center md:gap-2">
          <button
            disabled={buttonDisabled}
            className={` ${
              buttonDisabled
                ? "bg-[#f87171] cursor-not-allowed"
                : "bg-[#e31c23] hover:bg-red-700 cursor-pointer"
            }  text-white flex justify-center items-center w-full sm:w-[70px] rounded-md  h-[38px] mt-4 sm:mt-12 font-poppins font-semibold border border-none`}
            onClick={handleClearAll}
          >
            Clear All
          </button>
          <button
            disabled={!Asapdata?.values?.length}
            className={` ${
              loading || !Asapdata?.values?.length
                ? "bg-[#f87171] cursor-not-allowed"
                : "bg-[#e31c23]  cursor-pointer hover:bg-red-700"
            }  text-white flex justify-center items-center
                         w-full sm:w-[70px]  rounded-md  h-[38px] mt-2 md:mb-0 mb-1 sm:mt-12 font-poppins font-semibold border border-none `}
            onClick={(e) => {
              e.preventDefault();
              const isPrimaryAsinValid = Asapdata?.columns.includes("PRIMARY_ASIN");
              console.log("Export payload:", {
                MARKETING_ACTIVITY: selectMarketing || [],
                TITLE: selectTitle || [],
                FILE_NAME: selectedFile || [],
                heading: sortState?.heading || "",
                sortType: sortState?.sortType || "",
                // secondarySort: isPrimaryAsinValid
                //   ? sortState?.secondarySort || { heading: "PRIMARY_ASIN", sortType: sortState?.sortType || "asc" }
                //   : undefined,
              });
              downloadAsapdata({
                MARKETING_ACTIVITY: selectMarketing || [],
                TITLE: selectTitle || [],
                FILE_NAME: selectedFile || [],
                heading: sortState?.heading || "",
                sortType: sortState?.sortType || "",
                // secondarySort: isPrimaryAsinValid
                //   ? sortState?.secondarySort || { heading: "PRIMARY_ASIN", sortType: sortState?.sortType || "asc" }
                //   : undefined,
              });
            }}
          >
            Export
          </button>
        </div>
      </div>
      {Asapdata?.values?.length ? (
        <div
          ref={asapref}
          style={{ borderTop: "1px solid gray" }}
          className={`  overflow-auto max-h-[72vh] 4k:max-h-[50vh] 5k:max-h-[45vh] 3xl:max-h-[65vh] 2xl:max-h-[67vh] w-full`}
        >
          <table className="border-collapse w-full min-w-max  table-auto border-2 border-gray-400">
            <thead
              style={{ borderBottom: "1px solid gray", height: "60px" }}
              className="sticky top-[0px] z-10 bg-gray-200 m-header"
            >
              <tr>
                {Asapdata?.columns.map((col: any, index: any) => (
                  <th
                    key={index}
                    style={{
                      border: "1px solid gray",
                    }}
                    className={`px-6 text-gray-800 font-semibold border border-black cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis ${
                      col === "MARKETING_ACTIVITY"
                        ? "w-[150px]  2xl:w-[200px] 4k:w-[250px]"
                        : col === "START_DATE"
                        ? "w-[100px] 2xl:w-[120px] 4k:w-[170px]"
                        : col === "END_DATE"
                        ? "w-[100px] 2xl:w-[120px]"
                        : col === "PRIMARY_ASIN"
                        ? "w-[100px] 2xl:w-[120px]"
                        : col === "TITLE"
                        ? "w-[180px] 2xl:w-[220px] 4k:w-[350px]"
                        : col === "COVERAGE"
                        ? "w-[100px] 2xl:w-[130px] 4k:w-[150px] "
                        : col === "CATEGORY"
                        ? "w-[100px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "STATUS"
                        ? "w-[100px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "REJECTION_REASON"
                        ? "w-[80px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "ORIGIN"
                        ? "w-[100px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "CONFIRMATION_ID"
                        ? "w-[130px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "FILE_NAME"
                        ? "w-[150px] 2xl:w-[130px] 4k:w-[170px]"
                        : ""
                    }`}
                  >
                    <CommonHeader
                      column={col}
                      data={{ values: Asapdata.values }}
                      sortState={sortState}
                      onSort={handleSort}
                    />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Asapdata?.values.map((row: any, i: any) => (
                <tr key={i}>
                  {row.map((cell: any, j: any) => {
                    const isDash =
                      cell === null ||
                      cell === undefined ||
                      cell === "" ||
                      (typeof cell === "string" &&
                        cell.toLowerCase() === "nan");
                    const displayValue = isDash ? "-" : cell;
                    const colName = Asapdata.columns[j];
                    return (
                      <td
                        key={j}
                        className={`px-5 h-[50px]  py-1 2xl:py-3 5k:py-10 text-gray-700 border border-black text-sm ${
                          displayValue === "-" ? "text-center" : ""
                        }`}
                        style={{
                          border: "1px solid gray",
                          width: colName === "TITLE" ? "300px" : "auto",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          verticalAlign: "top",
                        }}
                      >
                        {displayValue}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="h-[30vh] flex items-center justify-center text-gray-500 font-semibold text-[15px] border border-gray-300">
          No data available
        </div>
      )}
    </>
  );
};

export default ASAPTable;